import React, { useState } from "react";
import { useField } from "formik";
import PasswordStatus from "../../../components/passwordStatus";

interface myProps {
  label: string;
  type?: string;
  placeholder: string;
  name: string;
  id: string;
  className?: string;
  required?: boolean;
}
const MyPasswordField: React.FC<myProps> = ({
  label,
  className,
  required,
  ...props
}) => {
  const [show, setShow] = useState<boolean>(false);
  const [field, meta] = useField(props);
  return (
    <>
      <div className="relative w-full flex flex-col ">
        <label
          className="font-medium text-base mt-3"
          htmlFor={props.id || props.name}
        >
          {label} {required && <span className="text-red-500 text-lg">*</span>}
        </label>
        <input
          className={` ${className}   border rounded-lg  ${
            meta.touched && meta.error ? "border-red-500" : "border-[#E2E5EA]"
          }  py-2 px-2 focus:border-[#E2E5EA] border-solid`}
          {...field}
          {...props}
          value={field.value || ""}
          type={show ? "text" : "password"}
        />
        <PasswordStatus
          setShowPassword={setShow}
          showPassword={show}
          className={`top-[55%] mt-[7px] left-[92%]`}
        />
      </div>
      {meta.touched && meta.error ? (
        <div className="error text-red-400">{meta.error}</div>
      ) : null}
    </>
  );
};

export default MyPasswordField;
